import { lazy } from 'react';

export enum ComponentsMapEnums {
  SITE_MANAGEMENT,
  SITE_SHIFT_MANAGEMENT,
  SHIFT_MANAGEMENT,
  AREA_MANAGEMENT,
  ROSTER_MANAGEMENT,
  MULTI_SITE_ROSTER_MANAGEMENT,
  ROSTER_PLAN,
  HOLIDAY_CONFIGURATIONS,
  LEAVE_CONFIGURATIONS,
  SEPARATION,
  ATTENDANCE_LOG,
  REGULARISATION,
  PUNCH_IN,
  PUNCH_OUT,
  OT_TOP_UP,
  SPOOF,
  PLANED_OT,
  PLANNED_OT_OVERTIME,
  EMPLOYEE_WITH_DIFFERENT_STATUS,
  APPROVAL_LEAVES_LIST,
  APPROVAL_SEPARATION_LIST,
  APPROVAL_ABSCONDING_LIST,
  APPROVAL_BGV_LIST,
  UPLOAD_REPORTS,
  DOWNLOAD_REPORTS,
  TEAM_MANAGEMENT,
  VENDORS,
  VENDOR_REPORT,
  CREATE_OT,
  EDIT_EMPLOYEES,
  BULK_REGULARISATION,
  SLOT_MANAGEMENT,
  FLEX_SITE_MANAGEMENT,
  FLEX_SITE_MANAGEMENT_DETAILS,
  FLEX_RATE_CARD_MANAGEMENT,
  FLEX_PAYOUT_MANAGEMENT,
  VENDOR_PAYOUT_VIEW,
  GRIEVANCE_MANAGEMENT,
  GRIEVANCE_DETAILS,
  TRANSFER_REQUESTS_TRACKER,
  TRANSFER_EMPLOYEE_HISTORY,
  APPROVAL_TRANSFERS,
  TRANSFER_REQUESTS_TRACKER_DETAILS,
  BULK_USER_CREATION,
  BLACKLIST_EMPLOYEE,
  MULTI_SESSION,
  REFERRAL_RATE_CARD_MANAGEMENT,
  ADDENDUM_MANAGEMENT,
  ADDENDUM_DETAILS,
  BULK_GRACE_ATTENDANCE,
  BULK_ROLE_UPDATE,
  FT_FLEX_RATE_CARD_MANAGEMENT,
  FT_FLEX_SLOT_MANAGEMENT,
  APPROVAL_IT_REVIEW_LIST,
  IT_APPROVALS_EMPLOYEE_ASSET,
  APPROVAL_POST_ONBOARDING,
}

export const ComponentsMap: {
  [key in keyof typeof ComponentsMapEnums]: any;
} = {
  SITE_MANAGEMENT: lazy(() => import('../../site-management/pages/site')),
  SITE_SHIFT_MANAGEMENT: lazy(
    () => import('../../site-management/pages/site/components/SiteDetailView'),
  ),
  SHIFT_MANAGEMENT: lazy(() => import('../../site-management/pages/shift')),
  AREA_MANAGEMENT: lazy(() => import('../../site-management/pages/area')),
  MULTI_SITE_ROSTER_MANAGEMENT: lazy(
    () => import('../../site-management/pages/multisite-roster'),
  ),
  ROSTER_PLAN: lazy(() => import('../../site-management/pages/roster-plan')),
  ROSTER_MANAGEMENT: lazy(() => import('../../site-management/pages/roster')),
  HOLIDAY_CONFIGURATIONS: lazy(
    () => import('../../leaves/pages/holiday-configuration'),
  ),
  LEAVE_CONFIGURATIONS: lazy(
    () => import('../../leaves/pages/leave-configuration'),
  ),
  SEPARATION: lazy(
    () =>
      import('../../blacklist-separation/pages/separation/pages/separation'),
  ),
  APPROVAL_LEAVES_LIST: lazy(() => import('../../approval/pages/leaves')),
  APPROVAL_SEPARATION_LIST: lazy(
    () => import('../../approval/pages/separation'),
  ),
  APPROVAL_ABSCONDING_LIST: lazy(
    () => import('../../approval/pages/absconding'),
  ),
  UPLOAD_REPORTS: lazy(
    () => import('../../reports/pages/reports-view/components/UploadedReports'),
  ),
  DOWNLOAD_REPORTS: lazy(
    () =>
      import('../../reports/pages/reports-view/components/DownloadsReports'),
  ),
  ATTENDANCE_LOG: lazy(() => import('../../attendance/pages/attendance-log')),
  MULTI_SESSION: lazy(() => import('../../attendance/pages/multi-session')),
  REGULARISATION: lazy(() => import('../../approval/pages/regularisation')),
  PUNCH_IN: lazy(() => import('../../approval/pages/punch-in')),
  PUNCH_OUT: lazy(() => import('../../approval/pages/punch-out')),
  OT_TOP_UP: lazy(() => import('../../approval/pages/ot-topup')),
  SPOOF: lazy(() => import('../../approval/pages/spoof')),
  BLACKLIST_EMPLOYEE: lazy(
    () => import('../../blacklist-separation/pages/blacklist'),
  ),
  PLANED_OT: lazy(() => import('../../approval/pages/planned-ot')),
  PLANNED_OT_OVERTIME: lazy(
    () =>
      import(
        '../../site-management/pages/overtime-management/pages/overtime-management/planned-ot'
      ),
  ),
  EMPLOYEE_WITH_DIFFERENT_STATUS: lazy(
    () =>
      import(
        '../../site-management/pages/overtime-management/pages/overtime-management/component/eligible-employee'
      ),
  ),
  TEAM_MANAGEMENT: lazy(() => import('../../team-management/pages/team')),

  APPROVAL_BGV_LIST: lazy(
    () => import('../../approval/pages/background-verification'),
  ),
  VENDORS: lazy(() => import('../../vendors/pages/vendors')),
  VENDOR_REPORT: lazy(
    () => import('../../vendors/pages/vendors/components/VendorReport'),
  ),
  CREATE_OT: lazy(
    () =>
      import(
        '../../site-management/pages/overtime-management/pages/overtime-management/component/create-ot/create-overtime-drawer'
      ),
  ),
  EDIT_EMPLOYEES: lazy(
    () =>
      import(
        '../../site-management/pages/overtime-management/pages/overtime-management/component/eligible-employee/edit-ot-employee'
      ),
  ),
  SLOT_MANAGEMENT: lazy(
    () => import('../../flex-management/pages/slot-management'),
  ),
  FLEX_RATE_CARD_MANAGEMENT: lazy(
    () => import('../../flex-management/pages/rate-card-management'),
  ),
  FLEX_PAYOUT_MANAGEMENT: lazy(
    () =>
      import(
        '../../flex-management/pages/payroll-management/component/FlexPayoutProcessing'
      ),
  ),

  FLEX_SITE_MANAGEMENT: lazy(
    () => import('../../flex-management/pages/site-management'),
  ),
  FLEX_SITE_MANAGEMENT_DETAILS: lazy(
    () =>
      import(
        '../../flex-management/pages/site-management/component/flex-site-management-details'
      ),
  ),
  VENDOR_PAYOUT_VIEW: lazy(
    () =>
      import(
        '../../payouts-and-incentive/pages/payout-processing/components/VendorPayout/VendorPayoutProcessingView'
      ),
  ),
  BULK_REGULARISATION: lazy(
    () => import('../../bulk-creation/bulk-regularisation'),
  ),
  BULK_USER_CREATION: lazy(
    () => import('../../bulk-creation/bulk-user-creation'),
  ),
  GRIEVANCE_MANAGEMENT: lazy(
    () => import('../../grievance-management/pages/grievanceManagement'),
  ),
  GRIEVANCE_DETAILS: lazy(
    () => import('../../grievance-management/pages/component/review-ticket'),
  ),
  TRANSFER_REQUESTS_TRACKER: lazy(
    () => import('../../transfer-management/pages/requests-tracker'),
  ),
  TRANSFER_EMPLOYEE_HISTORY: lazy(
    () => import('../../transfer-management/pages/employee-history'),
  ),
  APPROVAL_TRANSFERS: lazy(() => import('../../approval/pages/transfers')),
  TRANSFER_REQUESTS_TRACKER_DETAILS: lazy(
    () =>
      import(
        '../../transfer-management/pages/requests-tracker/components/DetailsContainer'
      ),
  ),
  REFERRAL_RATE_CARD_MANAGEMENT: lazy(
    () => import('../../referral/pages/rate-card-management'),
  ),

  ADDENDUM_MANAGEMENT: lazy(
    () => import('../../addendum-management/pages/AddendumManagement'),
  ),
  ADDENDUM_DETAILS: lazy(
    () =>
      import('../../addendum-management/pages/components/AddendumBatchDetails'),
  ),
  FT_FLEX_RATE_CARD_MANAGEMENT: lazy(
    () => import('../../ft-flex/rate-card-management'),
  ),
  FT_FLEX_SLOT_MANAGEMENT: lazy(() => import('../../ft-flex/slot-management')),
  BULK_GRACE_ATTENDANCE: lazy(
    () => import('../../bulk-creation/bulk-grace-attendance'),
  ),
  BULK_ROLE_UPDATE: lazy(() => import('../../bulk-creation/bulk-role-update')),
  APPROVAL_IT_REVIEW_LIST: lazy(() => import('../../approval/pages/it-review')),

  IT_APPROVALS_EMPLOYEE_ASSET: lazy(
    () => import('../../approval/pages/employee-asset'),
  ),
  APPROVAL_POST_ONBOARDING: lazy(
    () => import('../../approval/pages/post-onboarding'),
  ),
};
